import React from "react";
import {
    Box,
    Typography,
    Button,
    Chip,
    Divider,
    TextField,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    styled,
} from "@mui/material";
import PopupMarkdown from "../PopupTemplate/PopupMarkdown"; 
import { POPUP_MESSAGE_TYPES } from "./marketingConstants";

const CardPanel = styled(Box)({
    backgroundColor: "#0d2147",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "10px",
    color: "#ffffff",
    padding: "24px",
    width: "100%",
    minHeight: "545px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
});

const PreviewPopupCard = styled(Box)({
    backgroundColor: "#0d2147",
    color: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #1e3a70",
    padding: "24px",
    width: "100%",
    maxWidth: "560px",
    margin: "0 auto",
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.6)",
});

// const PreviewBody = styled(Box)({
//     "& .mm-heading": {
//         fontSize: "1.25rem",
//         fontWeight: 700,
//         margin: "0 0 8px 0",
//         color: "#fff",
//     },
//     "& .mm-paragraph": {
//         margin: "0 0 8px 0",
//         color: "#d1dcf0",
//         lineHeight: 1.6,
//     },
//     "& .mm-quote": {
//         borderLeft: "3px solid #3f69f8",
//         margin: "8px 0",
//         paddingLeft: "10px",
//         color: "#b0c4de",
//     },
//     "& .mm-list": { margin: "8px 0", paddingLeft: "20px", color: "#d1dcf0" },
//     "& strong": { color: "#ffffff" },
//     "& a": {
//         color: "#ffffff",
//         textDecoration: "underline",
//         textDecorationColor: "rgba(255, 255, 255, 0.5)",
//         fontWeight: 500,
//         "&:hover": {
//             color: "#d1dcf0",
//             textDecorationColor: "rgba(255, 255, 255, 0.75)",
//         },
//     },
//     "& code": {
//         background: "rgba(255,255,255,0.1)",
//         padding: "2px 4px",
//         borderRadius: "4px",
//     },
// });

const fieldSx = {
    "& .MuiOutlinedInput-root": {
        color: "#fff",
        backgroundColor: "#091730",
        "& fieldset": { borderColor: "rgba(255, 255, 255, 0.15)" },
        "&:hover fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" },
        "&.Mui-focused fieldset": { borderColor: "#3f69f8" },
    },
    "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" },
};

const typeBadgeColor = {
    info: "#3f69f8",
    action: "#28a745",
};

export default function MessagePreview({
    content,
    popupTitle,
    popupConfig,
    onPopupConfigChange,
}) {
    // const html = parseMarkdownToHtml(content);
    const { type = "info", action = "" } = popupConfig || {};
    const badgeColor = typeBadgeColor[type] || typeBadgeColor.info;
    const showActionButton = true; //type === "action" && action.trim().length > 0;

    const updateConfig = (patch) => {
        onPopupConfigChange?.({ ...popupConfig, ...patch });
    };

    return (
        <CardPanel>
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    mb: 2,
                }}
            >
                <FormControl size="small" sx={{ minWidth: 160, ...fieldSx }}>
                    <InputLabel id="popup-type-label">Popup type</InputLabel>
                    <Select
                        labelId="popup-type-label"
                        label="Popup type"
                        value={type}
                        onChange={(e) => updateConfig({ type: e.target.value })}
                    >
                        {POPUP_MESSAGE_TYPES.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value}>
                                {opt.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                { type == "action" ?
                <TextField
                    size="small"
                    label="Action (URL or label)"
                    value={action}
                    onChange={(e) => updateConfig({ action: e.target.value })}
                    placeholder="/subscription"
                    sx={{ flex: "1 1 200px", ...fieldSx }}
                />
                : <></>}
            </Box>

            <Divider
                sx={{ backgroundColor: "rgba(255, 255, 255, 0.08)", mb: 4 }}
            />

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                }}
            >
                <Typography
                    variant="subtitle2"
                    sx={{
                        color: "#7a9cff",
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                        fontWeight: 700,
                    }}
                >
                    User View Preview
                </Typography>
                <Chip
                    label="Live Modal Mockup"
                    size="small"
                    sx={{
                        backgroundColor: "rgba(112, 143, 245, 0.45)",
                        color: "#ffffff",
                        fontSize: "0.7rem",
                    }}
                />
            </Box>

            <Box
                sx={{
                    my: "auto",
                    py: 2,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <PreviewPopupCard>
                    <Typography
                        variant="caption"
                        sx={{
                            color: popupTitle ? badgeColor : "#cc1f1f",
                            fontWeight: 700,
                            letterSpacing: "0.5px",
                            textTransform: "uppercase",
                            display: "block",
                            mb: 1,
                        }}
                    >
                        {popupTitle || "<< missing title >>"}
                    </Typography>

                    <PopupMarkdown
                        content={content}
                        sx={{ mb: showActionButton ? 3 : 0 }}
                    />

                    {showActionButton && (
                        <Button
                            variant="contained"
                            fullWidth
                            href={
                                "#"
                                // action.startsWith("http") ||
                                // action.startsWith("/")
                                //     ? action
                                //     : undefined
                            }
                            sx={{
                                backgroundColor: "#3f69f8",
                                color: "#ffffff",
                                textTransform: "none",
                                fontWeight: 700,
                                py: 1.2,
                                borderRadius: "6px",
                                "&:hover": { backgroundColor: "#2b52d9" },
                            }}
                        >
                            {type == "info" || type == "insight" || action == "" || action == undefined ? "Ok" :
                                action.startsWith("http") || action.startsWith("/")
                                ? "Open →"
                                : action}
                        </Button>
                    )}
                </PreviewPopupCard>
            </Box>
        </CardPanel>
    );
}
